import { useEffect, useState } from 'react';
import { api } from './utils';
import { getTenant, getUserName } from './helpers';

const usePositionCompany = (
  isUpdate,
  positionData,
  setPositionData,
  setIsLoading
) => {
  const [companies, setCompanies] = useState([]);

  const reorderCompanies = (data, companyId) => {
    const companyIndex = data.findIndex((company) => company.id === companyId);
    if (companyIndex !== -1) {
      return [
        data[companyIndex],
        ...data.slice(0, companyIndex),
        ...data.slice(companyIndex + 1),
      ];
    }
    return data;
  };

  useEffect(() => {
    setIsLoading(true);
    api.ibldmcareer.getCompany(
      { org: getTenant(), username: getUserName() },
      (data) => {
        setIsLoading(false);

        const updatedCompanies = isUpdate
          ? reorderCompanies(data, positionData.company_id)
          : data;

        setCompanies(updatedCompanies);

        // Update the positionData with the first company ID
        setPositionData((prevState) => ({
          ...prevState,
          company_id: updatedCompanies.length > 0 ? updatedCompanies[0].id : 0,
        }));
      },
      (error) => {
        setCompanies([]);
        setIsLoading(false);
      }
    );
  }, []); 
  return { companies, setCompanies };
};

export { usePositionCompany };
